/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import styles from "./TextInput.module.scss";
import typeography from "ui/style/typography.module.scss"
import classnames from "classnames";

interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    className?: string;
}

const TextInput: React.FC<Props> = (props) => {
    return (
        <input {...props} className={classnames(props.className, styles.input, typeography.body)}/>
    );
}

export default TextInput;